// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-container {
  width: 100%;
  padding: 16px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 960px) {
  :where(.vuetify-styles) .v-container {
    max-width: 900px;
  }
}
@media (min-width: 1280px) {
  :where(.vuetify-styles) .v-container {
    max-width: 1200px;
  }
}
@media (min-width: 1920px) {
  :where(.vuetify-styles) .v-container {
    max-width: 1800px;
  }
}
@media (min-width: 2560px) {
  :where(.vuetify-styles) .v-container {
    max-width: 2400px;
  }
}
:where(.vuetify-styles) .v-container--fluid {
  max-width: 100%;
}
:where(.vuetify-styles) .v-container.fill-height {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VGrid/VContainer.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB","sourcesContent":[".v-container {\n  width: 100%;\n  padding: 16px;\n  margin-right: auto;\n  margin-left: auto;\n}\n@media (min-width: 960px) {\n  .v-container {\n    max-width: 900px;\n  }\n}\n@media (min-width: 1280px) {\n  .v-container {\n    max-width: 1200px;\n  }\n}\n@media (min-width: 1920px) {\n  .v-container {\n    max-width: 1800px;\n  }\n}\n@media (min-width: 2560px) {\n  .v-container {\n    max-width: 2400px;\n  }\n}\n.v-container--fluid {\n  max-width: 100%;\n}\n.v-container.fill-height {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
